import { http } from "../../../services/apiSecurity/Http.interceptor";
import { ResponsePagination } from "../../../core/interfaces/ResponsePagination";
import { Format } from "./interfaces/Format";

const URL: string = '/formats';

export const getFormat = (params?: any) => {
    return http.get<ResponsePagination>(URL, { params: params });
}

export const getByFormat = (id: number) => {
    return http.get<Format>(`${URL}/${id}`)
}

export const postFormat = (data: Format) => {
    return http.post<Format>(URL, data)
}

export const deleteFormat = (id: number) => {
    return http.delete<string>(`${URL}/${id}`)
}

export const putFormat = (data: Format) => {
    return http.put<Format>(`${URL}/${data.id}`, data)
}

export const getAllFormats = () => {
    return http.get<Format[]>(`/listAllFormats`)
}